import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import { handleStatus500 } from 'api/Utility/HandleStatus500'
import apiWrapper from 'api/Utility/ApiWrapper'

type Payload = {
  participant_segment_id: string
  filters: {
    search: string
  }
}

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    paramsSerializerConfig: true,
    encode: false,
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const EXPORT_PARTICIPANTS_URL = `site_users/export`

const exportUsersEndPoints = {
  exportUsers: (params: Payload) => {
    return axiosRequest().get(EXPORT_PARTICIPANTS_URL, { params })
  },
}

const exportUsersApi = {
  exportUsers: (params: Payload) =>
    apiWrapper({
      endPoint: exportUsersEndPoints.exportUsers,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default exportUsersApi
